/**
 * Detects Soniox / edge responses that indicate a bad or missing API key,
 * so we can show a user-friendly message instead of raw English from the SDK.
 */
export function isInvalidSonioxApiKeyError(message: string): boolean {
  const normalized = message.trim().toLowerCase();
  return normalized.includes("invalid api key") || normalized.includes("api key is invalid");
}
